import { createSvgIcon } from '@material-ui/core/utils';

export const DpCatalogIcon = createSvgIcon(
  <>
    <path d="M19.54 23.72H4.46c-1.09 0-1.97-.88-1.97-1.97V2.25c0-1.09.88-1.97 1.97-1.97h15.08c1.09 0 1.97.88 1.97 1.97v19.5c0 1.08-.88 1.97-1.97 1.97ZM4.46 1.56c-.38 0-.69.31-.69.69v19.5c0 .38.31.69.69.69h15.08c.38 0 .69-.31.69-.69V2.25c0-.38-.31-.69-.69-.69H4.46Z" />
    <path d="M15.01 6.79H8.99l-3 5.21 3 5.21h6.02l3-5.21-3-5.21z" />
  </>,
  'DpCatalogIcon',
);
